module.exports = __webpack_public_path__ + "static/img/celclassic.519c2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/pack/celclassic.png
// module id = G5mB
// module chunks = 12